import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { taskKeys, RequestTypes } from '@core/react-query/features/tasks/task'
import { tasksKeys } from '@core/react-query/features/tasks/tasks'
import { Task } from '@core/entities/task/Task'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { useMutateQueryData } from '@core/react-query/hooks'

export const useCancelTask = (
  options?: UseMutationOptions<
    Task,
    RequestErrorType,
    RequestTypes['cancelTask']
  >,
) => {
  const queryClient = useQueryClient()
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)

  return useMutation({
    ...taskKeys.cancelTask,
    ...options,
    onSuccess: (task, variables) => {
      queryClient.invalidateQueries({
        queryKey: taskKeys.byId({
          taskId: variables.id,
        }).queryKey,
      })

      queryClient.invalidateQueries({
        queryKey: ['task', 'timeline', variables.id],
      })

      updateInfiniteQueryItem(tasksKeys.myTasks._def, task)
      updateInfiniteQueryItem(tasksKeys.allTasks._def, task)
    },
  })
}
